<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      :type="type"
      ref="tableMain"
      @submit="submit"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :destinationPortName="destinationPortName"
        @query="getData"
      />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { Main, Header },
  props: {
    height: { type: Number, default: 300 },
    orderCode: { type: String, default: '' },
    type: { type: String, default: 'radio' },
    destinationPortName: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      loading: false,
      tableData: [],
    }
  },
  methods: {
    getData(form) {
      if (!this.orderCode) return
      this.loading = true
      this.$api
        .ordeDemandPackingListApi({
          orderCode: this.orderCode,
          ...form,
          ...this.page,
          pageSize: 1000, //设置查询最大条数为1000
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    choiceData() {
      this.$refs.tableMain.choiceData()
    },
    submit(data) {
      this.$emit('submit', data)
    },
  },
}
</script>
